import React from 'react';
import _ from 'lodash';
import './RichTextArea.scss'

const RichTextArea = ({textblob, className=''}) => <div className={`rich-text ${className}`} dangerouslySetInnerHTML={{__html: _.replace(textblob, /~\//g, "/")}}></div>;

export default RichTextArea;